/**
 * Navigation Handler
 * Handles browser back/forward button and prevents cached errors
 */

// ✅ Clear all error states when navigating
export const clearErrorStates = () => {
  try {
    // Clear any React error boundaries
    const errorBoundaries = document.querySelectorAll('[data-error-boundary]');
    errorBoundaries.forEach(el => el.remove());
    
    // Clear any error overlays
    const errorOverlays = document.querySelectorAll('iframe[title="React Error Overlay"]');
    errorOverlays.forEach(el => el.remove());

    console.log('✅ Error states cleared for navigation');
  } catch (e) {
    // Silent fail
  }
};

// ✅ Handle browser back/forward navigation
export const setupNavigationHandler = () => {
  // Listen for popstate (back/forward button)
  window.addEventListener('popstate', (event) => {
    console.log('🔙 Browser back/forward detected');
    
    // Clear any cached errors
    clearErrorStates();
  });
  
  // Listen for pageshow (back from bfcache - Firefox/Safari)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // Page loaded from back/forward cache
      console.log('📄 Page loaded from cache (bfcache)');
      
      // Clear cached errors
      clearErrorStates();
      
      // Reload page to ensure fresh state (optional, but safest)
      // Comment out if you don't want full reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  });
  
  // Listen for pagehide (before page unloads)
  window.addEventListener('pagehide', () => {
    // Clear error states before page unloads
    clearErrorStates();
  });
  
  // Listen for beforeunload (before navigating away)
  window.addEventListener('beforeunload', () => {
    // Clear error states
    clearErrorStates();
  });
  
  console.log('✅ Navigation handlers initialized');
};

/**
 * Optional console tagging in production only. Global UI for errors is handled by
 * setupGlobalErrorHandlers (toast), not by blanketing window.onerror here.
 */
export const forceErrorSuppression = () => {
  const isProduction =
    process.env.REACT_APP_ENV === 'production' || process.env.NODE_ENV === 'production'

  if (isProduction) {
    const originalError = console.error
    const originalWarn = console.warn

    console.error = (...args: any[]) => {
      originalError.apply(console, ['[app]', ...args])
    }

    console.warn = (...args: any[]) => {
      originalWarn.apply(console, ['[app]', ...args])
    }
  }

  console.log('✅ Error handling: toasts for user-visible errors (see setupErrorHandlers)')
}

